import React from "react";
import { Grid, Typography, Button } from "@material-ui/core";
import moment from "moment";
import { useHistory } from "react-router-dom";
import listados from "../../services/listados";

export default function MyAssingment(props) {
  let history = useHistory();
  const { classes, assignments } = props;
  const todayDateString = moment(new Date()).format("DD/MM/YYYY");
  const todayDate = new Date();
  return assignments.map((myAssignment, index) => {
    console.log(myAssignment.stringDate > todayDateString);
    return (
      <Grid
        item
        key={index}
        xs={12}
        md={4}
        lg={3}
        className={`${classes.items} ${
          myAssignment.stringDate === todayDateString
            ? classes.green
            : myAssignment.dateActivity.toDate() > todayDate
            ? classes.red
            : classes.orange
        }`}
      >
        <Typography variant="h6" color="textSecondary">
          {myAssignment.nameActivity} -{" "}
          {listados.profiles[myAssignment.profile]}
        </Typography>
        <Typography variant="body1" color="textSecondary">
          {myAssignment.stateText} - {myAssignment.municipalityText} -{" "}
          {myAssignment.meetingPoint}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {myAssignment.address}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {myAssignment.stringDate} {myAssignment.hour}
        </Typography>
        <br></br>
        <Button
          variant="outlined"
          size="small"
          color="primary"
          onClick={() => history.push(`/report/${myAssignment.id}`)}
          disabled={todayDateString === myAssignment.stringDate ? false : true}
          style={{ border: "1px solid #000", color: "#000" }}
        >
          Iniciar
        </Button>
      </Grid>
    );
  });
}
